import { dataHooks } from '../../../libs/dataHooks';

export const megaMenuDataHooks = dataHooks<{ toggle; dropdown }>('mega-menu');
